// i18n.setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export let i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'de',
  messages: {} // set locale messages
})

export async function loadCurrentTranslation (lang) {
  const msgs = await import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}`)
  i18n.locale = lang // set locale
  i18n.setLocaleMessage(lang, msgs.default)
  return lang
}
